/*
 *  Copyright © 2025 Cenozon Inc. All Rights Reserved.
 */
import React from 'react';

const wrapperStyle = {
   minHeight: '100vh',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
   background: '#f4f6f8',
   fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
   padding: '2rem'
};

const cardStyle = {
   maxWidth: 540,
   width: '100%',
   background: '#fff',
   borderRadius: 8,
   boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
   padding: '2.5rem',
   textAlign: 'center'
};

const titleStyle = {
   color: '#0071a3',
   margin: '0 0 0.75rem',
   fontSize: '1.5rem',
   fontWeight: 600
};

const messageStyle = {
   color: '#3a3a3a',
   margin: '0 0 1.5rem',
   lineHeight: 1.5
};

export default function AccessDenied({ message }) {
   const detail = message
      || 'Your Cenozon account is not provisioned for Insight. Contact Cenozon Support to request access.';

   return (
      <div style={wrapperStyle}>
         <div style={cardStyle}>
            <h1 style={titleStyle}>Account not provisioned</h1>
            <p style={messageStyle}>{detail}</p>
         </div>
      </div>
   );
}
